module.exports = __webpack_public_path__ + "img/download.50437f55.svg";